import { useState } from 'react';
import Card from '../../../../../../common/components/ContainerCard';
import { IAddress } from '../../../../../../models/Account/IAddress';
import styles from './AddressCard.module.css';

type AddressCardProps = {
  addressData: IAddress;
  onEdit: (address: IAddress) => void;
  onDelete: (addressData: IAddress) => void;
};

const AddressCard = (props: AddressCardProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleAddressChange = () => {
    props.onEdit(props.addressData);
  };

  return (
    <Card className={styles.smallCardDimensions}>
      <div className={styles.content}>
        <div className={styles.subtitleSmall}>{props.addressData.addressee}</div>
        <div className={styles.addressesLabel}>{props.addressData.addressLine1}</div>
        <div className={styles.addressesLabel}>{props.addressData.addressLine2}</div>
        <div className={styles.addressesLabel}>{props.addressData.city}</div>
      </div>
      <div className={styles.footer}>
        <div className={styles.linkBlue} onClick={handleAddressChange}>
          Edit
        </div>
      </div>
    </Card>
  );
};

export default AddressCard;
